import React from "react";
import ClientsSection from "./ClientsSection";
import ProjectsSection from "./ProjectsSection";
import PartnersSection from "./PartnersSection";
import CollaboratorsSection from "./CollaboratorsSection";
import ArticlesSection from "./ArticlesSection";

const Home = () => {
  return (
    <div>
     
      
      <PartnersSection />
     <CollaboratorsSection/>
      <ProjectsSection />
      <ClientsSection />
      <ArticlesSection />

      
    </div>
  );
};

export default Home;
